export const DB_NAME = 'blaster';
export const DB_VERSION = 2;

export const STORE_SETTINGS = 'settings';
export const STORE_RELAYS = 'relays';
export const STORE_NIP11 = 'nip11_cache';
export const STORE_DEDUPE = 'dedupe';
export const STORE_HISTORY = 'history';

export const SETTINGS_KEY = 'current';

export type HistoryKind = 'pubkey' | 'relay';
export const HISTORY_LIMIT = 100;
